import React, { ReactNode } from 'react'
import { Platform } from 'react-native'

import { FormattedMessage } from 'react-intl'

import Text from 'app/components/base/Text'
import useOpenExternalLink from 'app/hooks/useOpenExternalLink'
import { IS_NATIVE_APP, WEBSITE_URL } from 'app/utils/constants/env.constants'

const ReadTermLabel: RFC = () => {
  const { openLink } = useOpenExternalLink()

  const link = (chunk: ReactNode[], href: string, title: string): ReactNode => {
    const link = IS_NATIVE_APP ? `${WEBSITE_URL}/${href}` : href

    const onClick = () => openLink({ link, title })

    return (
      <Text
        variant="subtitle2"
        sx={{
          fontWeight: 500,
          color: 'primary.main',
          ...(!IS_NATIVE_APP && {
            display: 'inline',
            cursor: 'pointer',

            '&:hover': {
              color: 'secondary.dark'
            }
          })
        }}
        onClick={onClick}
      >
        {chunk}
      </Text>
    )
  }

  return (
    <Text
      variant="subtitle2"
      color="text.third"
      sx={{
        ...Platform.select({
          web: { pr: 2 },
          native: { flex: 1 }
        })
      }}
    >
      <FormattedMessage
        defaultMessage="By creating an account, you acknowledge that you have read and agree to the <linkFirst>User Agreement</linkFirst> and <linkSecond>Privacy Policy</linkSecond>"
        values={{
          linkFirst: (chunk) =>
            link(chunk, '/info/terms-and-conditions', 'Terms and Conditions'),
          linkSecond: (chunk) =>
            link(chunk, '/info/privacy-policy', 'Privacy Policy')
        }}
      />
    </Text>
  )
}

export default ReadTermLabel
